/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ViewUniformAttachments from "./UniformAttachment";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getUniformDetailApi } from "api/services/uniforms";
import { useUniform } from "../context/uniformContext";
import AllUniformAddPopup from "../../../../components/modelpopup/AllUniformAddPopup";
import AddStockTakeModal from "../../../../components/modelpopup/AddStockTakeModal";
import StockHistoryTable from "./StockHistoryTable";
import './styles.css';

const UniformDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const {
    loading,
    resumeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleUniformDetailPage,
    selectedPage,
    uniformModal,
    setSelectedUniform,
    setUniformModal,
    selectedUniform,
    setLoading
  } = useUniform();


  const [userData, setUserData] = useState({});
  const [uniformDetailData, setUniformDetailData] = useState([]);
  const [stockModal, setStockModal] = useState(false);
  const [refreshStockHistory, setRefreshStockHistory] = useState(0); 

  const displayUniformPos = (uniformPositions)=> {
    return (
      <>
  
    {uniformPositions.length > 0 ? (
      uniformPositions.map(item => (

        <>
          <span  style={{
          
              
              
              fontSize: "14px",
            }} className={"badge badge-soft-primary me-2 mb-2" } > {item.position.name} </span>
            </>
        

      ))
    ) : (
      <li>N.A.</li>
    )}
  {/* </ul> */}
      </>
    )
  }
  useEffect(() => {

    getUniformData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);


  const getUniformData = () => {
    if (params?.id) {
      getUniformDetailApi(params?.id).then((response) => {
        console.log(response, "REEEEEEE");
        setUserData(response.data);

        let sizes = response.data?.sizes;
        const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
        sizes.sort((a, b) => sizeOrder.indexOf(a.code) - sizeOrder.indexOf(b.code));

        let uniformPositions = response.data?.uniform_positions;

        let _gender = response.data?.gender;

        let gender = _gender === 'M' ? 'Male' : _gender === 'F' ? 'Female' : _gender === 'U' ? 'Unisex' : ''
        const isActive = response.data?.status || false; 

        let availableSizes = sizes.length > 0 ? sizes.map(size => size.code).join(", ") : "No sizes available";
       
        let uniformPos = uniformPositions.length > 0 
        ? displayUniformPos(uniformPositions)
        : ["N.A."];
      

        let _status =  <span 
        className={`badge ${isActive ? "badge-primary" : "badge-secondary"}`} 
        style={{ fontSize: "0.75rem", padding: "5px 10px", fontWeight: "bold" }}
      >
        {isActive ? "Active" : "Inactive"}
      </span>
      
        const uniformDetailData =  [
          { id: 1, title: "Uniform Name", text:response.data?.name},          
          { id: 3, title: "Gender", text:gender},
          { id: 4, title: "Positions", text:uniformPos},
          { id: 5, title: "Sizes", text:availableSizes},
          { id: 6, title: "Description", text: response.data?.description },
          { id: 7, title: "Status", text: _status},  
        ]
        setUniformDetailData(uniformDetailData) 

      });
    }
  }
  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = selectedPage + 1;
    if (nextIndex < pageSettings.total) {
      let nextEmployee = resumeData[nextIndex];
      handleUniformDetailPage(nextEmployee.id, nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = selectedPage - 1;
    if (prevIndex >= 0) {
      let nextEmployee = resumeData[prevIndex];
      handleUniformDetailPage(nextEmployee.id, prevIndex);
    }
  };

  const reloadPage = () => {
    getUniformData();
    setRefreshStockHistory(prev => prev + 1); // Trigger stock history refresh
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Uniform Detail"
            title="Uniforms"
            subtitle="Uniform Details"
            modal="#add_indicator"
            name="Add New"
            showModal={false}
            linkName="/uniforms"
          />
          


          <div className="contact-head">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <ul className="contact-breadcrumb">
                  <li>
                    <Link to="#" onClick={handleClickGoBack}>
                      <i className="las la-arrow-left" /> Uniforms
                    </Link>
                  </li>
                  <li>
                    {userData?.name} 
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 text-sm-end">
                <div className="contact-pagination">
                  <p>
                    {selectedPage + 1} of {pageSettings.total}
                  </p>
                  <ul>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickPrevious();
                        }}                       
                      >
                        <i className="las la-arrow-left" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickNext();
                        }}                      
                      >
                        <i className="las la-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12 ">
              <button 
                className="btn btn-primary"
                onClick={() => setStockModal(true)}
              >
                <i className="fa fa-plus me-2"></i>
                Add Stock Take
              </button>
            </div>
          </div>
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link to="#">
                          <img src={userData?.image} alt="Image" />
                        </Link>
                      </div>
                    </div>
                    <div className="profile-basic">
                    
                      <div className="ml-2 mt-3 row">                     
                        <div className="col-md-12">
                        <ul className="personal-info">
                        {uniformDetailData.map((item, index) => (
                          <ListItem
                            id={item.id}
                            key={index}
                            title={item.title}
                            text={item.text}
                          />
                        ))}
                  </ul>

                

                {/* <ViewUniformAttachments userData={userData} /> */}
           
                        </div>
                      </div>
                    </div>
                    <div className="pro-edit">
                      <Link
                      onClick={()=>{
                        setSelectedUniform(userData)
                        setUniformModal(true)
                      }}                   
                        className="edit-icon"                     
                      >
                        <i className="fa-solid fa-pencil"></i>
                      </Link>
                    </div>

                    <AllUniformAddPopup reloadPage={reloadPage} setSelectedUniform={setSelectedUniform} setLoading={setLoading} selectedUniform={selectedUniform} loading={loading}  uniformModal={uniformModal} setUniformModal={setUniformModal} />
                    <AddStockTakeModal 
                      stockModal={stockModal} 
                      setStockModal={setStockModal} 
                      uniformData={userData}
                      reloadPage={reloadPage}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>

        
          {/* Uniform Details */}
          {/* <UniformDetailTab userData={userData} /> */}

          {/* Stock History Table */}
          <StockHistoryTable uniformId={params?.id} refreshTrigger={refreshStockHistory} />
        </div>
      </div>
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);

export default UniformDetail;
